module.exports = __webpack_public_path__ + "static/media/bien-public-logo.3fb7f28f.jpg";